export default __webpack_public_path__ + "static/media/bTocIcon.e6fc6eae.png";